import { createStore, applyMiddleware } from 'redux';
import { reducer } from './reducers';
import thunk from 'redux-thunk';

import { loadState, saveState } from './localStorage';

export const configureStore = () => {
	const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
	const store = createStoreWithMiddleware(reducer, loadState());

	store.subscribe(() => {
		saveState(store.getState());
	});

	return store;
};



/** WEBPACK FOOTER **
 ** ./src/configureStore.js
 **/